(() => {
  const productInput = document.querySelector(".cc-product-buy-buttons--input-builder");
  const buttonSubmitForm = document.querySelector(".cc-product-buy-buttons--primary-builder");

  if (!productInput || !buttonSubmitForm) return;

  document
    .querySelectorAll(".cc-shop-all__item-footer [data-variant-id]")
    .forEach((button) => {
      if (button.dataset.shopAllBound === "true") return;

      button.dataset.shopAllBound = "true";
      button.addEventListener("click", (event) => {
        event.preventDefault();
        productInput.value = button.dataset.variantId;
        buttonSubmitForm.click();
      });
    });
})();
